import { Button, Flex, Title } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

interface ISectionProps {
  title: string;
  expanded?: boolean;
  showToggle?: boolean;
  onToggle?: () => void;
  expandLabel?: string;
  collapseLabel?: string;
  children: React.ReactNode;
}

export default function Section(props: ISectionProps) {
  const {
    title,
    expanded = false,
    showToggle = false,
    onToggle,
    expandLabel = '전체보기',
    collapseLabel = '간단히보기',
    children,
  } = props;

  return (
    <Flex
      direction="column"
      h="100%"
      p="sm"
      gap="md"
      style={(theme) => ({
        border: '1px solid var(--app-border-muted, var(--mantine-color-gray-3))',
        borderRadius: theme.radius.sm,
        backgroundColor: theme.white,
      })}
    >
      <Flex justify="space-between" align="center" gap="sm">
        <Title order={3} size="1rem" fw={500}>
          {title}
        </Title>
        {showToggle && (
          <Button
            variant="transparent"
            size="xs"
            px={0}
            onClick={onToggle}
            aria-expanded={expanded}
            rightSection={expanded ? <IconChevronUp size={16} stroke={1.8} /> : <IconChevronDown size={16} stroke={1.8} />}
          >
            {expanded ? collapseLabel : expandLabel}
          </Button>
        )}
      </Flex>
      {children}
    </Flex>
  );
}
